export default __webpack_public_path__ + "static/media/logo-ar.474c6d3e.svg";